import React, { useEffect, useState } from "react";
import { Form, Row, Divider, Col, Input, Checkbox, notification, Select, message, InputNumber } from "antd";
import api from '../../services/api';
import { FormGW, SelectPaginacao, Data, Adicionar, DrawerCliente } from "../../components";
import { useStateValue } from "../../state";
import { drawerActions, manutencaoActions, selectPaginadoActions } from "../../actions";
import { validarIE } from "../../services/funcoesIE";
import { MaskFormat } from "../../ValueObjects";
import { validarPlaca } from "../../services/funcoes";
import { PlusOutlined } from "@ant-design/icons";

export default function ManutencaoVeiculo({ formulario, carregando, aoSalvar, editando }) {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [fileList, setFileList] = useState([]);
    const [openDrawerCliente, setOpenDrawerCliente] = useState(false);
    const [formEndereco] = Form.useForm();
    const [codigoCliente, setCodigoCliente] = useState(null);

    useEffect(() => {
        if (!!manutencao.dados && !!manutencao.dados.vec_id && editando.editando) {
            formulario.setFieldsValue(manutencao.dados);
        } else {
            formulario.resetFields();
        }
        let lista = []
        let cliIdForm = formulario.getFieldValue("cli_id");
        if (cliIdForm) {
            lista.push({ name: "cli_id", campo: "IdCliente", value: cliIdForm })
        }
        if (lista.length > 0) {
            dispatch({ type: selectPaginadoActions.CHANGE, data: { itens: lista } });
        }
    }, [manutencao.dados, formulario, dispatch]);

    const salvarManutencao = (values) => {
        carregando(true);
        let retorno;
        let enderecoUrl = 'veiculoCliente/';

        if (!!values.vec_id) {
            enderecoUrl += `Editar`;
            api.put(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: "Operação concluída", description: "Os dados do Veículo foram salvos com sucesso!" });
                    retorno = res.data;
                }
            }, err => {
                notification.error({ message: "Erro ao processar a requisição.", description: "Ocorreu um erro ao tentar salvar os dados do Veículo. Por favor, tente novamente." });
            }).finally(
                () => {
                    carregando(false);
                    aoSalvar(retorno);
                    setFileList([]);
                }
            );
        } else {
            enderecoUrl += "Incluir"
            api.post(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: "Operação concluída", description: "Os dados do Veículo foram salvos com sucesso!" });
                    retorno = res.data;
                    dispatch({ type: manutencaoActions.CHANGE, data: { dados: res.data } });
                }
            }, err => {
                notification.error({ message: "Erro ao processar a requisição.", description: "Ocorreu um erro ao tentar salvar os dados do Veículo. Por favor, tente novamente." });
            }).finally(
                () => {
                    carregando(false);
                    aoSalvar(retorno);
                }
            );
        };
        if (!!values.vec_inscricaoestadual_numeroInscricaoEstadual && !validarIE(values.vei_inscricaoestadual_numeroInscricaoEstadual, values.vei_inscricaoestadual_ufestado)) {
            notification.warning({ message: 'Aviso', description: 'Inscrição Estadual informada é inválida' });
            return false;
        } else if (!!!values.vec_inscricaoestadual_numeroInscricaoEstadual) {
            values.vec_inscricaoestadual_numeroInscricaoEstadual = "";
        }
    }

    const validatorInput = (_, value) => {
        if (!value || /^[0-9]+$/.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject(new Error('Insira apenas números'));
    };

    return (
        <FormGW layout="vertical" form={formulario} name="manutencaoVeiculo" onFinish={salvarManutencao}>
            <Row gutter={[8, 0]}>
                <Col xs={24} sm={8} md={8} lg={12} xl={12}>
                    <Form.Item name="vec_id" hidden><Input /></Form.Item>
                    <Form.Item label="Cliente" name="cli_id" rules={[{ required: true, message: "Informe a descrição" }]}>
                            <SelectPaginacao url="Cliente/Listar"
                                funcaoIncluir={() => setOpenDrawerCliente(true)}
                                allowClear
                                placeholder="Selecione um Cliente"
                                form={formulario}
                                nameLabel="cli_id"
                                nameValue="cli_id"
                                conteudo={
                                    pc => (<Select.Option value={pc.cli_id} label={pc.pes_nome} key={pc.key}>{pc.cli_codigo} - {pc.pes_nome} <br />
                                        {(!!pc.pej_cnpj ? `CNPJ.: ${MaskFormat(pc.pej_cnpj, '', true)}` : !!pc.pef_cpf ? `CPF.: ${MaskFormat(pc.pef_cpf, '', true)}` : '')}
                                    </Select.Option>)
                                }
                            />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={16} md={16} lg={12} xl={12}>
                    <Form.Item name="vec_id" hidden><Input /></Form.Item>
                    <Form.Item label="Descrição" name="vec_descricao" rules={[
                        { required: true, message: "Informe a descrição" },
                        { min: 2, message: "No mínimo 2 caracteres" }
                    ]}>
                        <Input placeholder="Informe a Descrição" max={100} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Row gutter={[8, 0]} style={{ display: "flex", flexWrap: "wrap" }}>
                        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item label="Placa" name="vec_placa" rules={[{ required: true, message: "Informe a placa" }]}>
                                <Input
                                    placeholder="Informe a placa"
                                    maxLength={7}
                                    style={{ textTransform: 'uppercase' }}
                                    onBlur={(event) => validarPlaca(event, formulario, "vec_placa")}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item label="Modelo" name="vec_modelo" >
                                <Input placeholder="Informe o Modelo" maxLength={30} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item label="Cor" name="vec_cor" >
                                <Input placeholder="Informe a cor" maxLength={30} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item label="Chassi" name="vec_chassi" >
                                <Input placeholder="Informe o Chassi" maxLength={30} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item label="Km inicial" name="vec_kminicial">
                                <InputNumber placeholder="Informe a quilometragem" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item label="Ano de Fabricação" name="vec_anofabricacao" rules={[{ validator: validatorInput }]}>
                                <Input placeholder="Informe o Ano" maxLength={4} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item label="Ano do Modelo" name="vec_anomodelo" rules={[{ validator: validatorInput }]}>
                                <Input placeholder="Informe o Ano" maxLength={4} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item label="Marca" name="mav_id" >
                                <SelectPaginacao url="marcaVeiculo/Listar?Ativa=true"
                                    allowClear={true}
                                    selecionarRegUnico={"mav_id"}
                                    nameLabel="mav_descricao"
                                    nameValue="mav_id"
                                    placeholder="Selecione a Marca"
                                    form={formulario}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={9} sm={5} md={3} lg={5} xl={5}>
                            <Form.Item name="vec_ativo" initialValue={true} valuePropName="checked" className="t-mob-573">
                                <Checkbox>Veículo Ativo?</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>

                </Col>
            </Row>
             <DrawerCliente form={formEndereco} openDrawer={openDrawerCliente} setOpenDrawer={setOpenDrawerCliente} setCodigoCliente={setCodigoCliente} />
        </FormGW>
    )
}